<ng-container *ngIf=" permConfig.isViewAllowed">
    <div class="container-fluid">
        <app-page-title title="Rate Comparison"></app-page-title>
        <form [formGroup]="rateCompareForm" (ngSubmit)="searchRates()">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header bg-transparent border-bottom text-uppercase">Weight</div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-3 mt-3">
                                    <div class="input-group mb-2 mt-1">
                                        <span class="input-group-text group-label-sm">Actual <span
                                                class="mandatory">*</span></span>
                                        <input type="number" class="form-control form-control-sm"
                                            formControlName="txtActualWeight"
                                            [ngClass]="{'is-invalid': (isFormSubmitted || rateCompareForm.get('txtActualWeight')?.touched) && rateCompareForm.get('txtActualWeight').errors}"  >

                                        <span class="input-group-text group-label-sm">Volumetric</span>
                                        <input type="number" class="form-control form-control-sm"
                                            formControlName="txtVolumetricWeight"  >
                                        <div *ngIf="(isFormSubmitted || rateCompareForm.get('txtActualWeight')?.touched) && rateCompareForm.get('txtActualWeight').errors"
                                            class="invalid-feedback">
                                            <span
                                                *ngIf="rateCompareForm.get('txtActualWeight').errors.required">Required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <div class="mb-2 d-flex flex-column">
                                      <div class="label">
                                        <label for="rateFor" class="form-label">Rate for</label>
                                      </div>
                                      <div role="group" aria-label="radio button group" class="btn-group">
                                        <input type="radio" id="btnradio1" autocomplete="off" class="btn-check" (change)="applySwitchSelectedRateFor()"
                                          formControlName="rateFor" value="Customer" >
                                        <label for="btnradio1" class="btn btn-outline-secondary btn-sm">Customer</label>
                                        <input type="radio" id="btnradio2" autocomplete="off" class="btn-check" (change)="applySwitchSelectedRateFor()"
                                          formControlName="rateFor" value="Vendor" >
                                        <label for="btnradio2" class="btn btn-outline-secondary btn-sm">Vendor</label>
                                      </div>
                                    </div>
                                  </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="card">
                                        <div class="card-header bg-transparent border-bottom text-uppercase">Destination
                                        </div>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-md-2">
                                                    <div class="mb-2">
                                                        <label for="country" class="form-label">Country<span
                                                                class="mandatory">*</span></label>
                                                        <ng-select id="country" formControlName="ddlDestinationCountry"
                                                            placeholder="Select" [items]="countryList" bindLabel="name"
                                                            [bindValue]="'isocode'" [appendTo]="'body'" [openOnEnter]="false"
                                                            (change)="onCountryChange()"
                                                            [ngClass]="{'is-invalid': (isFormSubmitted || rateCompareForm.get('ddlDestinationCountry')?.touched) && rateCompareForm.get('ddlDestinationCountry').errors}"  ></ng-select>
                                                        <div *ngIf="(isFormSubmitted || rateCompareForm.get('ddlDestinationCountry')?.touched) && rateCompareForm.get('ddlDestinationCountry').errors"
                                                            class="invalid-feedback">
                                                            <span
                                                                *ngIf="rateCompareForm.get('ddlDestinationCountry').errors.required">Destination
                                                                Country is Required</span>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="col-md-2">
                                                    <div class="mb-2">
                                                        <label for="state" class="form-label">State</label>
                                                        <ng-select id="state" formControlName="ddlDestinationState"
                                                            placeholder="Select" [items]="destinationStateList"
                                                            bindLabel="name" [bindValue]="'isocode'" [appendTo]="'body'" [openOnEnter]="false"
                                                            (change)="onStateChange()"  />
                                                    </div>
                                                </div>
                                                <div class="col-md-2">
                                                    <div class="mb-2">
                                                        <label for="city" class="form-label">City</label>
                                                        <ng-select id="city" formControlName="ddlDestinationCity"
                                                            placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                                            [items]="destinationCityList" bindLabel="name"
                                                            [bindValue]="'isocode'"  />
                                                    </div>
                                                </div>
                                                <div class="col-md-2">
                                                    <div class="mb-2">
                                                        <label for="pincode" class="form-label">Pincode</label>
                                                        <input type="text" class="form-control form-control-sm"
                                                            id="pincode" placeholder="Search"
                                                            formControlName="txtDestPincode" [resultTemplate]="rt"
                                                            [inputFormatter]="formatter"
                                                            [ngbTypeahead]="searchDestinationPincode"  >
                                                        <ng-template #rt let-r="result" let-t="term">
                                                            <ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
                                                            <span> | {{r['code']}}</span>
                                                        </ng-template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <ngb-accordion #a="ngbAccordion" class="accordion range-accordion">
                            <ngb-panel id="1">
                                <ng-template ngbPanelTitle class="text-black">
                                    <i class="bx bx-search text-primary me-1"></i> Search and Filter
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-2">
                                                <div class="mb-2">
                                                    <label for="CustomerRate" class="form-label">Customer</label>
                                                    <ng-select id="CustomerRate" [items]="customerList" bindLabel="name"
                                                        placeholder="Select" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                                        formControlName="ddlCustomer"
                                                        [ngClass]="{'is-invalid': (isFormSubmitted || rateCompareForm.get('ddlCustomer')?.touched) && rateCompareForm.get('ddlCustomer').errors}"  >
                                                    </ng-select>
                                                    <div *ngIf="(isFormSubmitted || rateCompareForm.get('ddlCustomer')?.touched) && rateCompareForm.get('ddlCustomer').errors"
                                                        class="invalid-feedback">
                                                        <span
                                                            *ngIf="rateCompareForm.get('ddlCustomer').errors.required">Customer
                                                            is
                                                            Required</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="mb-2">
                                                    <label for="vendor" class="form-label">Vendor</label>
                                                    <ng-select id="vendor" [items]="vendorList" bindLabel="name"
                                                        placeholder="Select" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                                        formControlName="ddlVendor"
                                                        (change)="getAllVendorServices($event?.id, true)"
                                                        [ngClass]="{'is-invalid': (isFormSubmitted || rateCompareForm.get('ddlVendor')?.touched) && rateCompareForm.get('ddlVendor')?.errors}"  >
                                                    </ng-select>
                                                    <div *ngIf="(isFormSubmitted || rateCompareForm.get('ddlVendor')?.touched) && rateCompareForm.get('ddlVendor').errors"
                                                        class="invalid-feedback">
                                                        <span
                                                            *ngIf="rateCompareForm.get('ddlVendor').errors.required">Vendor
                                                            is
                                                            Required</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="mb-2">
                                                    <label for="service" class="form-label">Service</label>
                                                    <ng-select id="service" formControlName="ddlService"
                                                        placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" [items]="serviceList"
                                                        bindLabel="servicename" [bindValue]="'servicename'"  />
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="mb-2">
                                                    <label for="shipmentType" class="form-label">Shipment Type</label>
                                                    <ng-select id="shipmentType" formControlName="ddlShipmentType"
                                                        placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                                        [items]="shipmentTypeList" bindLabel="name" [bindValue]="'name'"
                                                        (change)="onChangeShipmentType()"  />
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="mb-2">
                                                    <label for="product" class="form-label">Product</label>
                                                    <ng-select [items]="filteredProductList" bindLabel="name"
                                                        [bindValue]="'code'" [appendTo]="'body'" [openOnEnter]="false"
                                                        formControlName="ddlProduct" placeholder="Select"
                                                        class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                                        [ngClass]="{'is-invalid': (isFormSubmitted || rateCompareForm.get('ddlProduct')?.touched) && rateCompareForm.get('ddlProduct').errors}"  ></ng-select>
                                                    <div *ngIf="(isFormSubmitted || rateCompareForm.get('ddlProduct')?.touched) && rateCompareForm.get('ddlProduct').errors"
                                                        class="invalid-feedback">
                                                        <span
                                                            *ngIf="rateCompareForm.get('ddlProduct').errors.required">Product
                                                            is
                                                            Required</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card-header bg-transparent border-bottom text-uppercase mb-2 mt-1">Origin
                                        </div>
                                        <div class="row">
                                            <div class="col-md-2">
                                                <div class="mb-2">
                                                    <label for="country" class="form-label">Country</label>
                                                    <ng-select id="country" formControlName="ddlOriginCountry"
                                                        placeholder="Select" [items]="countryList" bindLabel="name"
                                                        [bindValue]="'isocode'" [appendTo]="'body'" [openOnEnter]="false"
                                                        (change)="onCountryChange('origin')"
                                                        [ngClass]="{'is-invalid': (isFormSubmitted || rateCompareForm.get('ddlOriginCountry')?.touched) && rateCompareForm.get('ddlOriginCountry').errors}"  ></ng-select>
                                                    <div *ngIf="(isFormSubmitted || rateCompareForm.get('ddlOriginCountry')?.touched) && rateCompareForm.get('ddlOriginCountry').errors"
                                                        class="invalid-feedback">
                                                        <span
                                                            *ngIf="rateCompareForm.get('ddlOriginCountry').errors.required">Origin
                                                            Country is Required</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="mb-2">
                                                    <label for="state" class="form-label">State</label>
                                                    <ng-select id="state" formControlName="ddlOriginState"
                                                        placeholder="Select" [items]="originStateList" bindLabel="name"
                                                        [bindValue]="'isocode'" [appendTo]="'body'" [openOnEnter]="false"
                                                        (change)="onStateChange('origin')"  />
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="mb-2">
                                                    <label for="city" class="form-label">City</label>
                                                    <ng-select id="city" formControlName="ddlOriginCity"
                                                        placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                                        [items]="originCityList" bindLabel="name"
                                                        [bindValue]="'isocode'"  />
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="mb-2">
                                                    <label for="pincode" class="form-label">Pincode</label>
                                                    <input type="text" class="form-control form-control-sm" id="pincode"
                                                        placeholder="Search" formControlName="txtOriginPincode"
                                                        [resultTemplate]="rt" [inputFormatter]="formatter"
                                                        [ngbTypeahead]="searchOriginPincode"  >
                                                    <ng-template #rt let-r="result" let-t="term">
                                                        <ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
                                                        <span> | {{r['code']}}</span>
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </ngb-panel>
                        </ngb-accordion>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 mb-2">
                    <div class="button-items">
                        <button type="submit" class="btn btn-primary btn-sm w-sm" >Search Rates</button>
                        <button type="button" class="btn btn-secondary btn-sm w-sm" (click)="resetForm()">Reset</button>
                    </div>
                </div>
            </div>
        </form>
        <div class="row">
            <div class="col-12 mt-2">
                <div class="card">
                    <div class="card-header bg-transparent border-bottom text-uppercase">Available Rates</div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-2 mb-2">
                                <button type="button" class="btn btn-primary btn-sm d-flex" 
                                    (click)="exportExcel()">Export
                                    <i class="bx bx-download font-size-16 px-1"></i>
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid"
                                    class="ag-theme-balham" [rowData]="rowData" [columnDefs]="columnDefs"
                                    [animateRows]="true" [context]="context" [defaultColDef]="defaultColDef"
                                    [suppressMenuHide]="true" [pagination]="true" (gridReady)="onGridReady($event)"
                                    [gridOptions]="gridOptions">
                                </ag-grid-angular>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>
</ng-container>

<ng-container *ngIf="!permConfig.isViewAllowed">
    <app-forbidden></app-forbidden>
</ng-container>